import React from "react";

const SvgDuplicate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M3 7V8H2C1.725 8 1.48958 7.90208 1.29375 7.70625C1.09792 7.51042 1 7.275 1 7V2C1 1.725 1.09792 1.48958 1.29375 1.29375C1.48958 1.09792 1.725 1 2 1H7C7.275 1 7.51042 1.09792 7.70625 1.29375C7.90208 1.48958 8 1.725 8 2V3H7V2H2V7H3ZM5 11C4.725 11 4.48958 10.9021 4.29375 10.7063C4.09792 10.5104 4 10.275 4 10V5C4 4.725 4.09792 4.48958 4.29375 4.29375C4.48958 4.09792 4.725 4 5 4H10C10.275 4 10.5104 4.09792 10.7063 4.29375C10.9021 4.48958 11 4.725 11 5V10C11 10.275 10.9021 10.5104 10.7063 10.7063C10.5104 10.9021 10.275 11 10 11H5ZM5 10H10V5H5V10Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDuplicate;
